import { Image } from 'app/src/shared/components/Image'
import { replaceUrlInString } from 'app/src/shared/helpers'
import posteXTeRibbon from 'app/static/images/postexte_ribbon.svg'
import { Card } from 'primereact/card'
import { type ReactElement, type ReactNode } from 'react'
import { useTranslation } from 'react-i18next'

export function ProductSubcategoryCard(props: {
  mainImage?: string
  parentCategoryImage?: string
  name: string
  description: string | ReactNode
  isSubcategory?: boolean
  isPartnership?: boolean
  onClick: () => void
  isFavourite?: boolean
}): ReactElement {
  const { t } = useTranslation('productDetail')
  return (
    <Card
      data-testid={'ProductSubcategoryCard-Card'}
      pt={{ root: { className: 'relative select-none cursor-pointer' }, content: { className: 'p-0' } }}
      tabIndex={0}
      role='link'
      onKeyDown={(event) => {
        if (event.key === ' ' || event.key === 'Enter') {
          props.onClick()
        }
      }}
      onClick={props.onClick}
    >
      {props.isPartnership ? (
        <Image
          aria-hidden
          className='absolute left-0 top-0 z-[1]'
          src={posteXTeRibbon}
          alt={t('ProductDetail.productPartnership.altPosteXTe')}
          data-testid='hide-in-storybook'
        />
      ) : (
        ''
      )}
      <div className='relative m-0 grid min-h-[124px] grid-cols-12 gap-4 p-0'>
        <div className='col-span-3'>
          <div className='image-container aspect-w-1 max-h-[124px] w-full overflow-hidden'>
            <Image
              aria-hidden
              src={props.mainImage ?? props.parentCategoryImage}
              className='w-full rounded object-cover'
              alt={props.name}
              fallbackImage={props.parentCategoryImage}
              data-testid='hide-in-storybook'
            />
          </div>
        </div>
        <div className='col-span-8'>
          <p className='mb-4 truncate font-bold text-[var(--primary-color)]'>{props.name}</p>
          {typeof props.description === 'string' ? (
            <div
              className='line-clamp-3 overflow-hidden'
              dangerouslySetInnerHTML={{
                __html: replaceUrlInString(props.description),
              }}
            ></div>
          ) : (
            <div className='line-clamp-3 overflow-hidden'>{props.description}</div>
          )}
        </div>
        {props.isSubcategory && (
          <div className='col-span-1 content-center'>
            <i className='pi pi-angle-right'></i>
          </div>
        )}
      </div>
      {props?.isFavourite && (
        <div className='absolute right-0 top-0 flex h-[48px] w-[48px] items-start justify-end rounded bg-[var(--primary-color)] pr-1 pt-2'>
          <i className='pi pi-star-fill text-[16px] text-white'></i>
          <div className='absolute right-0 top-0 h-0 w-0 border-l-[48px] border-t-[48px] border-l-white border-t-transparent'></div>
        </div>
      )}
    </Card>
  )
}
